import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useDeleteParticipantQRMutation } from '../../graphql/hooks/useDeleteParticipantQRMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  qrId: string;
  qrName: string;
}

export const ParticipantQRDeleteModal = createModal<Props>((props) => {
  const { participantId, qrId, qrName, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();

  const mutation = useDeleteParticipantQRMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        qrId,
      })
      .then(async () => {
        successToast('QR code deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting QR code: ${err.message}`);
      });
  }, [mutation, organization.id, participantId, qrId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this QR code?'
      description={
        <ChakraV3.Stack gap={4}>
          <ChakraV3.Text>
            Deleting this QR code <strong>will remove associated recordings.</strong>
          </ChakraV3.Text>
          <ChakraV3.AlertBanner
            size='sm'
            status='info'
            alignItems='center'
            title='If you want to keep the recordings, consider archiving the QR code instead.'
          />
        </ChakraV3.Stack>
      }
      confirmation={{ level: 'Level2', confirm: qrName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
